export default __webpack_public_path__ + "static/media/anchor.9edbe284.svg";